import { ActionHandler } from '../../common/actions/core/action-handler';
import { UserResponse } from '../../common/services/user/user.model';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import GlobalSpinnerService from '../../common/services/spinner/global-spinner.service';
import UserService from '../../common/services/user/user.service';
import { Action } from '../../common/actions/core/action';
import { OpenDoubleOptDialogAction } from './double-opt-dialog.action';
import { OpenDoubleOptSuccessDialogAction } from './success/double-opt-success-dialog.action';
import PackageService from '../../common/services/package/package.service';
import { PackageThumbnail, ListeningPackageType } from '../../common/services/package/package.model';
import GoogleAnalyticsService from '../../common/services/analytics/google-analytics.service';
import { OpenDoubleOptWarningDialogAction } from './warning/double-opt-warning-dialog.action';

/*@ngInject*/
export default class OpenDoubleOptDialogController implements ActionHandler {
  public smsCode: string;
  public valid: boolean = true;
  public time: string;
  public errorMessage: string;
  public isReqSend: boolean;
  protected package: PackageThumbnail;
  protected paymentMethodId?: number;
  protected cardId?: string;
  protected dialogElement;
  protected dialogOptions;

  protected onSuccess: (packageData) => any;
  protected onError: (error) => any;
  protected onTimeOut: () => any;

  protected user: UserResponse;

  private timer: any = null;
  private lastTwentyMinutes: boolean = false;
  private title: string;

  constructor(
    protected $element,
    private $q,
    private $interval,
    private $sce,
    private $translate,
    private $state,
    protected actionDispatcher: ActionDispatcherService,
    protected globalSpinner: GlobalSpinnerService,
    protected userService: UserService,
    private packageService: PackageService,
    private googleAnalytics: GoogleAnalyticsService,
    private config
  ) {}

  public $postLink() {
    this.dialogElement = this.$element.find('#double-opt-dialog').remodal();
    this.actionDispatcher.register(this);
  }
  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof OpenDoubleOptDialogAction) {
      this.reset();
      this.handleDialogAction(action);
    }
  }

  protected handleDialogAction(action: OpenDoubleOptDialogAction) {
    this.onSuccess = action.onSuccess;
    this.onError = action.onError;
    this.onTimeOut = action.onTimeOut;
    this.package = action.packageData;
    this.paymentMethodId = action.paymentMethodId;
    this.cardId = action.cardId;

    this.$translate('dialog.doubleOpt.title', this.package).then(value => {
      this.title = this.$sce.trustAsHtml(value);
    });

    if (!this.package) {
      return;
    }
    
    this.packageService.checkRelated(this.package).then((response) => {
     if(response.offerId != this.package.relatedSDP){
      this.globalSpinner.stop();
      this.$translate('dialog.doubleOpt.warning.description', this.package).then(value => {
        this.actionDispatcher.dispatch(new OpenDoubleOptWarningDialogAction(() => this.buyMethod(),this.package, this.$sce.trustAsHtml(value)));
      });
      return;
     } else if(response.price != this.package.price){
      this.globalSpinner.stop();
      this.$translate('mobilodeme.price.warning.description', response).then(value => {
        this.actionDispatcher.dispatch(new OpenDoubleOptWarningDialogAction(() => this.buyMethod(),this.package, this.$sce.trustAsHtml(value)));
      });
     }else{
      this.buyMethod();
     }
    }).catch(error => {
      this.buyMethod();
    });
  }

  public buyMethod(){
    if (!this.config.enableOTP) {
      this.buyWithoutOTP();
    } else {
      this.globalSpinner.start();
      this.resetTimer();
      this.$q
        .all([
          this.userService.getUserInfo(),
          this.packageService.getPermAndGeneratePassword(
            this.package,
            this.paymentMethodId
          )
        ])
        .then(data => {
          this.user = data[0];
          this.openDialog();
          this.startTimer();
        })
        .finally(() => {
          this.globalSpinner.stop();
        });
    }
  }

  protected onApprove() {
    if (!this.validate()) {
      return;
    }
    this.isReqSend = true;
    this.packageService
      .validatePasswordAndBuy(this.package, this.smsCode, this.paymentMethodId, this.cardId)
      .then(() => {
        this.close();
        var self = this;
        window.setTimeout(function() {
          self.resetTimer();
          if (angular.isFunction(self.onSuccess)) {
            self.onSuccess(self.package);
          }
        }, 500);
      })
      .catch(error => {
        this.resetTimer();
        this.startTimer();

        const code = !!error && !!error.code ? error.code : 'default';
        this.errorMessage = `error.message.${code}`;
        this.smsCode = '';
        this.googleAnalytics.sendGAEvent('Failure',this.package,error, 'bill');
      })
      .finally(() => {
        this.isReqSend = false;
      });
  }

  private buyWithoutOTP() {

    this.globalSpinner.start();
    this.isReqSend = true;
    this.packageService.validatePasswordAndBuy(this.package, null, this.paymentMethodId, this.cardId).then(() => {
        this.close();
        var self = this;
        window.setTimeout(function () {
          if (angular.isFunction(self.onSuccess)) {
            self.onSuccess(self.package);
          }
        }, 500);
      }).catch(error => {
        const code = !!error && !!error.code ? error.code : 'default';
        this.errorMessage = `error.message.${code}`;
        this.smsCode = '';
        this.googleAnalytics.sendGAEvent('Failure', this.package, error, 'bill');
      }).finally(() => {
        this.isReqSend = false;
        this.globalSpinner.stop();
      });

  }

  protected onResendPassword() {
    this.errorMessage = '';
    this.resetTimer();
    this.packageService
      .getPermAndGeneratePassword(this.package, this.paymentMethodId)
      .then(() => {
        this.startTimer();
      })
      .catch(() => {
        this.close();
        this.resetTimer();
      })
      .finally(() => {});
  }

  public onClick() {
    this.close();
  }

  private openDialog() {
    this.dialogElement.open();
  }

  public onCancel() {
    this.close();
  }

  private close() {
    this.dialogElement.close();
    this.errorMessage = '';
    this.isReqSend = false;
  }

  protected reset() {
    this.resetTimer();
    this.package = undefined;
    this.user = undefined;
    this.smsCode = undefined;
  }

  protected resetTimer() {
    // Cancel the Timer.
    if (angular.isDefined(this.timer)) {
      this.$interval.cancel(this.timer);
    }

    this.time = '02:00';
    this.lastTwentyMinutes = false;
  }

  private validate(): boolean {
    this.valid = this.smsCode && this.smsCode.trim().length > 0;
    return this.valid;
  }

  private startTimer() {
    const countDownDate = new Date().getTime() + 2 * 60000;
    this.timer = this.$interval(() => {
      // Get todays date and time
      const now = new Date().getTime();

      // Find the distance between now an the count down date
      const distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // If the count down is over, write some text
      if (distance < 0) {
        this.resetTimer();
        this.onStopTimer();
        return;
      }

      if (minutes < 1 && seconds < 21) {
        this.lastTwentyMinutes = true;
      }

      // Output the result
      this.time = '0' + minutes + ':' + (seconds > 9 ? seconds : '0' + seconds);
    }, 1000);
  }

  public onStopTimer() {
    this.close();
    this.resetTimer();
    var self = this;
    window.setTimeout(function() {
      self.onTimeOut();
    }, 500);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/double-opt-dialog/double-opt-dialog.controller.ts